
import './assets/css/loya-app.scss';
import  SHA1 from 'crypto-js/sha1';

let getVersion = function( callback ) {

    let xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open('GET', '/assets/frontend/js/version.json?t=' +  ( new Date() ).getTime() );
    xhr.onload = function() {

        if (xhr.status === 200 && xhr.readyState === 4) {
            try {
                let parsedVersion = JSON.parse(xhr.responseText);
                callback(parsedVersion);
            } catch (e) {}
        }
    }

    xhr.send();
}


export default
(function(a,b,c){b=document,c='addEventListener';b[c]?b[c]('DOMContentLoaded',a):window.attachEvent('onload',a)})(function(){
    document.forms[0].onsubmit = function() {

        var password_user = document.getElementById('password_user');
        document.getElementById('password').value = SHA1( password_user.value ).toString();
        password_user.setAttribute('disabled','disabled');

    }

    getVersion( version => {
        if (typeof version !== 'object')
            return;

        let container = document.getElementById('version');
        if (container) {
            container.innerText = 'v ' + version.version +' (build ' + version.build +')';
        }

    });

});

